import { memo, useMemo } from 'react';

import { usePhotoSwipeLightbox } from '../../../../../../hooks/use-photo-swipe-lightbox';
import image1HD from '../../images/detail/detail-1-hd.png';
import image1 from '../../images/detail/detail-1.png';
import image2HD from '../../images/detail/detail-2-hd.png';
import image2 from '../../images/detail/detail-2.png';
import image3HD from '../../images/detail/detail-3-hd.png';
import image3 from '../../images/detail/detail-3.png';
import image4HD from '../../images/detail/detail-4-hd.png';
import image4 from '../../images/detail/detail-4.png';
import image5HD from '../../images/detail/detail-5-hd.png';
import image5 from '../../images/detail/detail-5.png';
import image6HD from '../../images/detail/detail-6-hd.png';
import image6 from '../../images/detail/detail-6.png';
import image7HD from '../../images/detail/detail-7-hd.png';
import image7 from '../../images/detail/detail-7.png';
import image8HD from '../../images/detail/detail-8-hd.png';
import image8 from '../../images/detail/detail-8.png';

import './product-intro-list.scss';

const id = 'detail-intro-list';

export const ProductIntroList: React.FC = memo(() => {
  usePhotoSwipeLightbox(id);

  const images = useMemo(() => {
    return [
      {
        url: image1,
        hdUrl: image1HD,
        width: 2070,
        height: 3720,
      },
      {
        url: image2,
        hdUrl: image2HD,
        width: 2070,
        height: 2448,
      },
      {
        url: image3,
        hdUrl: image3HD,
        width: 2070,
        height: 2808,
      },
      {
        url: image4,
        hdUrl: image4HD,
        width: 2070,
        height: 3153,
      },
      {
        url: image5,
        hdUrl: image5HD,
        width: 2070,
        height: 2181,
      },
      {
        url: image6,
        hdUrl: image6HD,
        width: 2070,
        height: 2376,
      },
      {
        url: image7,
        hdUrl: image7HD,
        width: 2070,
        height: 4632,
      },
      {
        url: image8,
        hdUrl: image8HD,
        width: 2070,
        height: 2343,
      },
    ];
  }, []);

  return (
    <div id={id}>
      {images.map((image, index) => (
        <img
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className="previewable"
          styleName="img"
          draggable={false}
          src={image.url}
          alt=""
          data-pswp-src={image.hdUrl}
          data-pswp-width={image.width}
          data-pswp-height={image.height}
        />
      ))}
    </div>
  );
});
